import { API_BASE, API_V1, apiClient, publicClient } from "./client";
import { authApi } from "../store/api/authApi";
import { runMutation, runQueryNoArg } from "../store/api/runtime";

interface AuthResponseDto {
  token?: string;
  refreshToken?: string;
  user?: {
    id?: string;
    name?: string;
    username?: string;
    email?: string;
    phone?: string;
    phoneVerified?: boolean;
    location?: string | null;
    [key: string]: unknown;
  };
  message?: string;
}
export const API = API_BASE;

export async function login(email: string, password: string): Promise<AuthResponseDto> {
  return runMutation(authApi.endpoints.login.initiate, { email, password });
}

export async function register(payload: Record<string, unknown>): Promise<AuthResponseDto> {
  return runMutation(authApi.endpoints.register.initiate, payload);
}

export async function fetchMe(): Promise<Record<string, unknown>> {
  return runQueryNoArg(authApi.endpoints.fetchMe.initiate);
}

export async function sendPhoneOtp(phone: string): Promise<{ message?: string }> {
  return runMutation(authApi.endpoints.sendPhoneOtp.initiate, { phone });
}

export async function verifyPhoneOtp(phone: string, code: string): Promise<AuthResponseDto> {
  return runMutation(authApi.endpoints.verifyPhoneOtp.initiate, { phone, code });
}

export async function requestPasswordReset(email: string, redirectTo?: string): Promise<{ message?: string }> {
  return runMutation(authApi.endpoints.forgotPassword.initiate, { email, redirectTo });
}

export async function resetPassword(accessToken: string, password: string): Promise<{ message?: string }> {
  return runMutation(authApi.endpoints.resetPassword.initiate, { accessToken, password });
}

export { apiClient, publicClient, API_V1 };
export type { AppApiError } from "./client";
